import React from "react";

const GifContainer = ({ gifFiles }) => {
    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            flexWrap: "wrap", 
            justifyContent: "center",
            alignItems: "center",
            gap: "10px", 
            minHeight: "100vh",
        }}>
            {gifFiles.map((file, index) => (
                <img
                    key={index}
                    src={file}
                    alt={`gif-${index}`}
                    style={{
                        width: "100%",
                        maxWidth: "5000px", 
                        height: "45%",  
                    }}
                />
            ))}
        </div>
    );
};

export default GifContainer;
